import { render, staticRenderFns } from "./areaChild.vue?vue&type=template&id=79e7fd3c&scoped=true&"
import script from "./areaChild.vue?vue&type=script&lang=js&"
export * from "./areaChild.vue?vue&type=script&lang=js&"
import style0 from "./areaChild.vue?vue&type=style&index=0&id=79e7fd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7fd3c",
  null
  
)

export default component.exports